import React, { useState } from 'react'
import Table from 'UI/Table'
import { Query } from 'Utilities/incognitaAPI'
import { TOGGLE_ALERTING_ENABLED } from '../Queries'
import useColumns from './useColumns'
import { isEmpty } from 'lodash'

const MonitorableAssets = ({
  monitorableAssets: monitorableAssetsProps,
  setAssetToRemove
}) => {
  const [monitorableAssets, setMonitorableAssets] = useState(monitorableAssetsProps)

  const handleToggleLoading = id => {
    let monitorableAssetsCopy = [...monitorableAssets]

    monitorableAssetsCopy = monitorableAssetsCopy.map(asset => {
      if (asset.id == id) {
        asset.toggleLoading = true
        return asset
      } else return asset
    })
    
    setMonitorableAssets(monitorableAssetsCopy)
  }

  const toggleAlertingEnabled = id => {
    handleToggleLoading(id)

    Query(TOGGLE_ALERTING_ENABLED, { id })
      .then(response => {
        const { alertingEnabled } = response.toggleAlertingEnabled.logicmonitorMonitorableAsset

        const monitorableAssetsCopy = [...monitorableAssets].map(asset => {
          if (asset.id == id) {
            asset.alertingEnabled = alertingEnabled
            asset.toggleLoading = false
            return asset
          } else return asset
        })

        setMonitorableAssets(monitorableAssetsCopy)
      })
  }

  const columns = useColumns({ toggleAlertingEnabled, setAssetToRemove })

  if(isEmpty(monitorableAssets)) return null

  return (
    <Table
      data={monitorableAssets}
      columns={columns}
      showPagination={false}
    />  
  )
}

export default MonitorableAssets
